/* eslint-disable */
import _ from 'underscore';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import * as _DataRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import EditorView from '@bingads-webui-campaign-legacy/adextension-sitelink/view/extensionEditor';
import oldPreviewTemplate from '@bingads-webui-campaign-legacy/adextension-sitelink/template/preview.pug';
import previewTemplate from '@bingads-webui-campaign-legacy/adextension-sitelink/template/sitelinkPreview.pug';
import config from '@bingads-webui-component-legacy/config/index';
import rowTemplate from '@bingads-webui-campaign-legacy/adextension-sitelink/template/gridRowTemplate.pug';
import * as _panelDecorator from '@bingads-webui-campaign-react/panel-decorator';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
var newschema = window.globalLegacySchema.get('Sitelink2AdExtension');
var DataRepository = _DataRepository.default;
var panelDecorator = _panelDecorator.panelDecorator;
var repository;
var i18nKeys = {
  title: 'AdExtensions_Type_Sitelink',
  subtitle: 'NewCampaign_AddSitelinkAdExtension_Subtitle',
  library_title: 'AdExtensions_Sitelink_Editor_Available',
  selected_title: 'AdExtensions_Sitelink_Editor_Selected',
  create_link: 'AdExtensions_CreateSiteLink_CreateNew',
  create_title: 'AdExtensions_CreateSiteLink_Title',
  delete_btn: 'AdExtensions_Sitelink_Editor_Delete',
  delete_confirm: 'AdExtensions_Delete_SiteLink_Confirmation',
  edit_btn: 'AdExtensions_Sitelink_Editor_Edit',
  edit_title: 'AdExtensions_EditSiteLink_Title',
  inlineAlert: 'AdExtensions_Sitelink_Max_Select_Notification'
};
var view = AssociationsEditorBase.extend({
  initialize: function (options) {
    var Editor = options && options.usePanel ? panelDecorator(EditorView, {
      i18n: i18n,
      panelReadyAriaLabel: i18n.getString('Association editor side panel opened'),
      panelClassName: options.panelClassName
    }) : dialogDecorator.decorate(EditorView, {
      position: 'center',
      maxWidth: 1050
    });
    var maxSelectedItemCount = 1;
    var currentPreviewTemplate = oldPreviewTemplate;
    repository = new DataRepository({
      schema: newschema,
      associationsDataFormatter: function (data) {
        return _.map(data, function (item) {
          var ret = item.AdExtension;
          return ret;
        });
      },
      afterChangeComitted: function () {
        if (_.isFunction(options.updateContext)) {
          options.updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
        }
      }
    });
    maxSelectedItemCount = 20;
    options.orderBy = 'DisplayText';
    currentPreviewTemplate = previewTemplate;
    _.extend(options || ({}), {
      data: repository,
      template: {
        preview: currentPreviewTemplate,
        rowTemplate: rowTemplate
      },
      maxSelectedItemsCount: maxSelectedItemCount,
      extensionType: 'SitelinkExtension',
      CreateForm: Editor,
      EditForm: Editor,
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || ({})),
      processItem: function (item) {
        item.Description1 = _.isString(item.Description1) ? item.Description1 : '';
        item.Description2 = _.isString(item.Description2) ? item.Description2 : '';
        return item;
      }
    });
    AssociationsEditorBase.prototype.initialize.call(this, options);
  }
});
export default view;

